module.exports = __webpack_public_path__ + "static/media/platform.7311524b.svg";